import { render, staticRenderFns } from "./comment-creer-un-site-internet-de-chirurgien.vue?vue&type=template&id=08e9455a&scoped=true&"
import script from "./comment-creer-un-site-internet-de-chirurgien.vue?vue&type=script&lang=js&"
export * from "./comment-creer-un-site-internet-de-chirurgien.vue?vue&type=script&lang=js&"
import style0 from "./comment-creer-un-site-internet-de-chirurgien.vue?vue&type=style&index=0&id=08e9455a&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e9455a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/app/components/Header.vue').default,Scroll: require('/app/components/Scroll.vue').default,Button: require('/app/components/Button.vue').default,FooterV2: require('/app/components/FooterV2.vue').default})
